import React, { useState } from "react";
import Manajemen1 from "./manajemen1";
import Manajemen2 from "./manajemen2";
import UserTable from "./manajementable";
import AdminModal from "./adminmodal";
import Editmodal from "./editmodal";

export default function ManajemenPengguna() {
  const [searchQuery, setSearchQuery] = useState(""); // Centralized search state
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal visibility state
  const [isEditModalOpen, setIsEditModalOpen] = useState(false); // Modal visibility state
  const [selectedUser, setSelectedUser] = useState(null); // Store selected user for editing
  const [refreshKey, setRefreshKey] = useState(0);
  const handleSaved = () => setRefreshKey(k => k + 1);

  const handleEditAdmin = (user) => {
    setSelectedUser(user);
    setIsEditModalOpen(true);
  }
  return (
    <div className="relative h-full w-full">
      <div className="relative">
        <Manajemen1 />
        <UserTable
          onAddAdmin={() => setIsModalOpen(true)}
          onEditAdmin={handleEditAdmin} // Pass the handleEditAdmin function
          refreshKey={refreshKey}           // 👈 pass the key to table
        />
        {isModalOpen && <AdminModal onClose={() => setIsModalOpen(false)} onSaved={handleSaved} />}
        {isEditModalOpen && (
          <Editmodal
            user={selectedUser} // Pass the selected user to Editmodal
            onClose={() => setIsEditModalOpen(false)}
            onSaved={handleSaved}  // parent reload function
          />
        )}
      </div>
    </div>
  );
}
